export function getCurrentPSTDateAndTimeISO() {
  const now = new Date();

  // Formatters for PST
  const dateFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });

  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });

  const dateParts = dateFormatter.formatToParts(now);
  const timeParts = timeFormatter.formatToParts(now);

  const getPart = (parts, type) => parts.find(p => p.type === type).value;

  const year = getPart(dateParts, "year");
  const month = getPart(dateParts, "month");
  const day = getPart(dateParts, "day");

  const hour = getPart(timeParts, "hour");
  const minute = getPart(timeParts, "minute");
  const second = getPart(timeParts, "second");

  return {
    lastAppliedDate: `${year}-${month}-${day}`,
    lastAppliedDateTime: `${year}-${month}-${day}T${hour}:${minute}:${second}Z`
  };
}
